<template>
  <div class="w-100 mt-5">
    <div class="bg-white p-4">
      <div class="d-flex flex-column" style="max-width: 700px">
        <label class="font-bold text-lg text-title">{{ formTitle }}</label>
        <hr />
        <div class="d-flex w-100 align-items-center">
          <span style="flex: 1">Content Text Title</span>
          <CustomInput
            type="text"
            :inputStyle="{
              flex: 4,
            }"
            :placeholder="'Example: Promo wording'"
            :value="data.content_title"
            @onChange="(value) => (data.content_title = value)"
            maxlength="32"
            lengthIndicator
            :error="errors.content_title"
          />
        </div>
        <div
          v-for="(content, i) in data.content_data"
          :key="'content' + i"
          class="d-flex p-3 border rounded mt-4 position-relative"
          style="gap: 1rem"
        >
          <button
            v-if="i"
            class="btn position-absolute"
            style="right: 0; top: 5px"
            @click="handleDelete(i)"
          >
            <font-awesome-icon
              icon="fa-solid fa-trash"
              class="text-danger fw-bold"
            />
          </button>
          <div class="d-flex flex-column" style="flex: 1">
            <label class="mb-2" :for="'param' + i"> Parameter </label>
            <CustomInput
              :id="'param' + i"
              type="text"
              :placeholder="'Example: Title'"
              :value="content.param"
              @onChange="(value) => (content.param = value)"
              :error="errors['param' + i]"
            />
          </div>
          <div class="w-100" style="flex: 4">
            <label class="mb-2" :for="'value' + i"> Value </label>
            <TextEditor
              :key="'editor' + i"
              :value="content.value"
              @onChange="(val) => (content.value = val)"
            />
            <span v-if="errors['value' + i]" class="text-danger error-text">{{
              errors["value" + i]
            }}</span>
          </div>
        </div>
        <button
          class="p-3 d-flex border-0 rounded fw-bold mt-4 align-items-center"
          style="gap: 1rem; background-color: #f3f2f8; color: #5e50a1"
          @click="handleAdd()"
        >
          <font-awesome-icon icon="fa-solid fa-plus" />
          Add Sub Content
        </button>
        <div class="d-flex mt-4 justify-content-end" style="gap: 1rem">
          <button
            class="btn btn-lg btn-outline-danger w-100"
            style="max-width: 180px"
            @click="handleDiscard"
          >
            DISCARD
          </button>
          <button
            class="btn btn-lg btn-danger w-100"
            style="max-width: 180px"
            @click="handleSave"
          >
            SAVE
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput.vue";
import TextEditor from "@/components/TextEditor.vue";
export default {
  components: {
    TextEditor,
    CustomInput,
  },
  data() {
    return {
      prevData: {},
      data: {
        content_title: "",
        content_data: [{ param: "", value: "" }],
      },
      errors: {},
    };
  },
  computed: {
    isEdit() {
      return this.$route.params.id !== "add";
    },
    formTitle() {
      if (!this.isEdit) return "New Content Text";
      return `Edit Content Text`;
    },
  },
  async mounted() {
    if (this.isEdit) {
      const res = await this.$store.dispatch(
        "contentText/getOneContent",
        this.$route.params.id
      );
      // make shallow copy
      const obj = { ...JSON.parse(JSON.stringify(res.data)) };
      this.prevData = { ...obj };
      this.data = { ...obj };
    }
  },
  methods: {
    handleAdd() {
      const obj = { param: "", value: "" };
      const arr = [...this.data.content_data, obj];
      this.data.content_data = arr;
    },
    handleDelete(index) {
      const arr = [...this.data.content_data];
      arr.splice(index, 1);
      this.data.content_data = arr;
    },
    handleDiscard() {
      if (!this.isEdit) {
        this.data = {
          content_title: "",
          content_data: [{ param: "", value: "" }],
        };
      } else {
        const obj = { ...this.prevData };
        this.data = obj;
      }
    },
    checkValidation(payload) {
      let obj = {};
      if (!payload.content_title) {
        obj.content_title = "Content title cannot be empty";
      }
      payload?.content_data?.forEach((item, i) => {
        if (!item.param) {
          obj["param" + i] = "Param cannot be empty";
        }
        if (!item.value) {
          obj["value" + i] = "Value cannot be empty";
        }
      });
      this.errors = obj;
      if (Object.keys(obj).length) return false;
      return true;
    },
    async handleSave() {
      const body = { ...this.data };
      if (!this.checkValidation(body)) {
        return;
      }
      console.log({ body });

      try {
        let msg = "";
        if (!this.isEdit) {
          msg = "Success add content text";
          await this.$store.dispatch("contentText/createContent", body);
        } else {
          msg = "Success edit content text";
          await this.$store.dispatch("contentText/updateContent", {
            id: this.$route.params.id,
            body,
          });
        }

        this.$swal({
          icon: "success",
          title: msg,
          showConfirmButton: false,
          timer: 1500,
        }).then(() => {
          this.$router.push("/marketing/content-text");
        });
      } catch (err) {
        console.log("ERROR FORM CONTENT TEXT", err);
        let msg =
          err.response?.data?.errorMessage ||
          err.message ||
          "Something went wrong";

        this.$swal({
          title: msg,
          icon: "warning",
          timer: 2000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
